/**
 * React Quill expects an HTML string. Legacy APIs sometimes store Draft-style
 * objects ({ id, text }) or raw { blocks: [...] } — coerce to a safe string.
 */
export function richTextForQuill(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    if (typeof value.text === "string") return value.text;
    if (Array.isArray(value.blocks)) {
      return value.blocks
        .map((b) => (b && typeof b.text === "string" ? b.text : ""))
        .join("\n");
    }
  }
  return "";
}

/** Plain text / list items: allow numbers & booleans; coerce legacy rich objects. */
export function asRenderableText(value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  return richTextForQuill(value);
}
